import React, { useEffect } from "react";
import { Breadcrumbs, Link as MuiLink, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import decorline from "../../assets/images/decorline.svg";
import storeLocator from "../../assets/images/locationpin.svg";
import phoneIocn from "../../assets/images/phoneIcon.svg";
// import AvenueMalls from "../malls/AvenueMalls";
import Footer2 from "../../component/footer/Footer2";
import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import { fetchMalls } from "../../redux/slice/malls/malls";
import Spinner from "../../component/spinner/Spinner";
import "./DlfMalls.scss";

const DlfMall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { mallsData, loading } = useSelector((state) => state.malls);
  const breadcrumbs = [
    <MuiLink
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </MuiLink>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      DLF Malls
    </Typography>,
  ];
  const breadcrumbsMobile = [
    <MuiLink
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => {
        console.log("yo");
        
        navigate("/home")}}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </MuiLink>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      DLF Malls
    </Typography>,
  ];

  useEffect(() => {
    dispatch(fetchMalls());
  }, []);

  const getValue = (data, type, returnValue = "") => {
    if (data?.length > 0) {
      const result = data?.find((item) => item.type === type);
      if (returnValue?.length > 0) {
        return result[returnValue];
      } else {
        return result;
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="home">
        <div className="heading mobile_content head1">
          <div
            className="container pt-5 in-mobile mobile_content"
            style={{ position: "absolute", top: "24px", left: "16px" }}
          >
            <Breadcrumbs
              separator={
                <NavigateNextIcon fontSize="small" sx={{ color: "#A9A9A9" }} />
              }
              aria-label="breadcrumb"
            >
              {breadcrumbsMobile}
            </Breadcrumbs>
          </div>
          <h1
            style={{
              background: "linear-gradient(90deg, #F5E1C1, #DD9F4F)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              color: "transparent",
            }}
          >
            <img src={decorline} alt="" /> DLF Malls
            <img src={decorline} alt="" />
          </h1>
          <p className="para">Explore all the malls of DLF across Delhi NCR</p>
        </div>
        <div className="sidebar pt-5">
          <div className="container pb-5 in-mobile desktop_content">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside />
              </div>
              <div className="col-lg-8 col-md-8">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-pointHistory"
                        role="tabpanel"
                        aria-labelledby="v-pills-pointHistory-tab"
                        tabIndex="0"
                      >
                        <div className="dlfmall_container">
                          <div className="heading desktop_content">
                            <h1>
                              <img src={decorline} alt="" /> DLF Malls{" "}
                              <img src={decorline} alt="" />
                            </h1>
                            <p>Explore all the malls of DLF across Delhi NCR</p>
                          </div>

                          {/* List of malls */}

                          <div className="d-flex flex-wrap justify-center malls-cont">
                            {mallsData?.length > 0 ? (
                              <>
                                {mallsData?.map((item) => {
                                  const {
                                    mall_name,
                                    phone_number,
                                    mall_image,
                                    Additional_Details
                                  } = item?.attributes;
                                  const thumbnailImage =
                                    mall_image?.data?.attributes?.formats
                                      ?.thumbnail?.url;   
                                      const mallAddress =  getValue(
                                        Additional_Details?.data,
                                        "Location",
                                        "subtitle"
                                      );
                                      const googleMapsLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mallAddress)}`;                                                                       
                                  return (
                                    <React.Fragment key={item?.id}>
                                      <div className="malls-box col-lg-6" style={{border: "1px solid #1D1D1B12", borderRadius: "10px"}}>
                                        <Link
                                          to="/avenueMalls"
                                          className="removeAnchorPropertty"
                                          state={{ data: item }}
                                        >
                                          <img
                                            className="mallimg"
                                            src={`https://d3kj4cuhkbykh5.cloudfront.net${thumbnailImage}`}
                                            alt="mall image"
                                            loading="lazy"
                                          />
                                          <div className="d-flex align-items-start"></div>
                                          <div className="mall_description">
                                            <h6>{mall_name}</h6>
                                            <div className="d-flex">
                                              <div className="">
                                                <img
                                                  className="storelocator"
                                                  src={storeLocator}
                                                  alt=""
                                                />
                                              </div>
                                              <p>
                                              <a href={googleMapsLink} target="_blank" rel="noopener noreferrer" 
                                              style={{ textDecoration: 'none', color: 'inherit' }}
                                              onClick={(e) => e.stopPropagation()}>
                                              {mallAddress}
                                              </a>
                                            </p>
                                            </div>
                                           { phone_number && <div className="d-flex phone_row">
                                             <div className="">
                                                <img
                                                  className="storelocator"
                                                  src={phoneIocn}
                                                  alt=""
                                                />
                                              </div>                                       
                                              <p>
                                                <a
                                                  href={`tel:${phone_number}`}
                                                  style={{
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                  }}
                                                  onClick={(e) => e.stopPropagation()}
                                                >
                                                  {phone_number}
                                                </a>
                                              </p> 
                                            </div>}
                                          </div>
                                        </Link>
                                      </div>
                                    </React.Fragment>
                                  );
                                })}
                              </>
                            ) : null}
                          </div>

                          {loading && mallsData?.length === 0 ? (
                            <div className="spinner_table_height">
                              <Spinner color="black" />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      <Footer2 selected="home" />
    </div>
  );
};

export default DlfMall;
